const TAB_ROUTES = ['/tabs/home', '/tabs/library', '/tabs/all', '/tabs/me'];

let activeTransition = null;
let transitionId = 0;

function isEnabled() {
  if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_NODE_ENV === 'local') {
    return true;
  }

  try {
    return localStorage.getItem('debugTabTransitions') === 'true';
  } catch (_) {
    return false;
  }
}

function now() {
  return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
}

function isTabRoute(path) {
  return TAB_ROUTES.some(route => path === route || path?.startsWith(route + '/'));
}

function matchesActiveTarget(path) {
  return (
    activeTransition &&
    (path === activeTransition.toPath || path?.startsWith(activeTransition.toPath + '/'))
  );
}

function markPerformance(label) {
  if (typeof performance === 'undefined' || !performance.mark) return;
  try {
    performance.mark(label);
  } catch (_) {
    return;
  }
}

function durationFromStart(value) {
  if (!activeTransition || typeof value !== 'number') return null;
  return Math.round(value - activeTransition.start);
}

function emitMetrics() {
  if (!activeTransition || activeTransition.logged) return;

  const metrics = {
    from: activeTransition.fromPath,
    to: activeTransition.toPath,
    routeReadyMs: durationFromStart(activeTransition.routeReady),
    viewEnteredMs: durationFromStart(activeTransition.viewEntered),
    nextPaintMs: durationFromStart(activeTransition.nextPaint),
  };

  activeTransition.logged = true;

  if (typeof console !== 'undefined') {
    console.table ? console.table([metrics]) : console.log('[Tabs] transition metrics', metrics);
  }

  activeTransition = null;
}

export function markTabTransitionStart(fromPath, toPath, targetIndex) {
  if (!isEnabled() || !isTabRoute(toPath)) return;

  transitionId += 1;
  activeTransition = {
    id: transitionId,
    fromPath,
    toPath,
    targetIndex,
    start: now(),
    routeReady: null,
    viewEntered: null,
    nextPaint: null,
    logged: false,
  };

  markPerformance(`tab-transition:${transitionId}:start`);
}

export function markTabRouteReady(path) {
  if (!isEnabled() || !matchesActiveTarget(path)) return;

  activeTransition.routeReady = now();
  markPerformance(`tab-transition:${activeTransition.id}:route-ready`);
}

export function markTabViewEntered(path) {
  if (!isEnabled() || !matchesActiveTarget(path)) return;

  activeTransition.viewEntered = now();
  markPerformance(`tab-transition:${activeTransition.id}:view-entered`);

  const schedulePaint =
    typeof requestAnimationFrame === 'function'
      ? requestAnimationFrame
      : callback => setTimeout(callback, 0);

  schedulePaint(() => {
    if (!matchesActiveTarget(path)) return;
    activeTransition.nextPaint = now();
    markPerformance(`tab-transition:${activeTransition.id}:next-paint`);
    emitMetrics();
  });
}
